export const DIALOG_CONFIRM_SHOW = 'DIALOG_CONFIRM_SHOW'
export const DIALOG_CONFIRM_HIDE = 'DIALOG_CONFIRM_HIDE'
export const DIALOG_CONFIRM_SPINNER = 'DIALOG_CONFIRM_SPINNER'
export const DIALOG_CONFIRM_RESET = 'DIALOG_CONFIRM_RESET'
